import React from 'react'

const Questions = () => <h6 className="white-text">Questions? Call (612) 444-3395</h6>

export default Questions
